import React from 'react'
import PropTypes from 'prop-types'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {Helmet} from 'react-helmet'
import {useSiteContext} from '../../../contexts/site'

/**
 * Builds a set of Open Graph + meta tags for category pages.
 *
 * @param {Object} category - Category object from SFCC
 * @param {string} siteId - Current site ID
 * @returns {Array} Array of meta tag objects
 */
const getPageMetaTags = (category, siteId, isYR) => [
    {id: 'og:type', value: category?.id ? 'Category' : 'website'},
    {id: 'og:site_name', value: siteId},
    {
        id: 'og:title',
        value: category?.id
            ? category?.c_pageTitle
            : 'Search | ' + (isYR ? 'Yellow Rose' : 'Kendra Scott')
    },
    {id: 'description', value: category?.c_pageDescription},
    {id: 'og:url', value: ''}, // Built manually in component
    {
        id: 'title',
        value: category?.id
            ? category?.c_pageTitle
            : 'Search | ' + (isYR ? 'Yellow Rose' : 'Kendra Scott')
    },
    {id: 'og:description', value: category?.c_pageDescription}
]

/**
 * MetaTags component: renders SEO + OG meta tags dynamically
 */
const MetaTags = ({
    productSearchResult = {},
    category = {},
    enableBloomreachSearch = false,
    hostUrl = ''
}) => {
    const {site} = useMultiSite()
    const {isYR} = useSiteContext()
    const metaTags = enableBloomreachSearch
        ? getPageMetaTags(category, site?.id, isYR)
        : productSearchResult?.pageMetaTags

    return (
        <Helmet>
            {metaTags?.map((tag) => {
                const isOgTag = tag.id.startsWith('og:')
                const content =
                    tag.id === 'og:url'
                        ? category?.id
                            ? `${hostUrl}${category?.c_url}`
                            : ''
                        : tag.value

                return isOgTag
                    ? content && <meta key={tag.id} property={tag.id} content={content} />
                    : content && <meta key={tag.id} name={tag.id} content={content} />
            })}

            {category && <link rel="canonical" href={`${hostUrl}${category?.c_url}`} />}

            <title>{metaTags?.find((tag) => tag.id === 'title')?.value}</title>
        </Helmet>
    )
}

MetaTags.propTypes = {
    productSearchResult: PropTypes.object,
    category: PropTypes.object,
    hostUrl: PropTypes.string,
    enableBloomreachSearch: PropTypes.bool
}

export default MetaTags
